import React, { useEffect, useRef, useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import AuthService from "../services/AuthService";
import DialogBox from "../components/common/DialogBox";
import useAxios from "../hooks/useAxios";
import Constants from "../Constants";
import XButton from "../components/common/XButton";
import { cn } from "../utils/classNames";
import NavItem from "./nav/NavItem";
import NavBrand from "./nav/NavBrand";
import RenderIf from "../components/render-if/Renderif";
import { navLinkClasses, navButtonItemClasses } from "./nav/navClasses";

const SuperAdminLayout = () => {

    const navigate = useNavigate();
    const loggedInUserDetailsSubscriber = useRef(null);
    const [profilePictureImageUrl, setProfilePictureImageUrl] = useState("");
    const [open, setOpen] = useState(false)
    const { postData } = useAxios()

    useEffect(() => {
        if (window.location.pathname === '/') {
            navigate('/Companies');
        }
        const loggedInUser = AuthService.GetLoggedInUserData();
        setProfilePictureImageUrl(loggedInUser.profileImageUrl);
        registerLoggedInUserDetailsSubscriber();

        return () => {
            loggedInUserDetailsSubscriber.current.unsubscribe();
        }

    }, [navigate])



    const registerLoggedInUserDetailsSubscriber = () => {
        loggedInUserDetailsSubscriber.current = AuthService.LoggedInUserDetails.subscribe(value => {
            const imageUrl = value.profileImageUrl;
            setProfilePictureImageUrl(imageUrl);
        })
    }

    const Islogout = () => {
        postData(Constants.ApiUrl.logout.logout,{}).then((res) => {
            // LoggedInUserService.UpdateLoggedInUserSession(res?.data?.token);
            localStorage.clear();
            if (window.location.hostname === "master.demandpro.law") {
                navigate('/account/SAlogin');
            } else if (window.location.hostname !== "master.demandpro.law") {
                navigate('/account/login');
            }
            console.log(res, "res in the add companies");
        }).catch(err => {
            console.log(err, "error in the add companies");
        })
    }
    return <>

        <TopNavBar
            profileImageUrl={profilePictureImageUrl}
            open={open} setOpen={setOpen}
            navigate={navigate}
            Islogout={Islogout}
        />
        {/* Home Routes render section */}
        <Outlet />
        <DialogBox description={'Are you sure want to Logout'} open={open} handleSubmit={() => {
                Islogout()
            }} handleClose={() => setOpen(false)} />
    </>
}

// Fixed 72px bar on desktop; height stays auto below lg so the menu can expand.
const navClasses =
    "relative flex flex-wrap items-center justify-between " +
    "py-2 lg:py-0 lg:h-nav-height lg:flex-nowrap lg:justify-start d-navbar";

const navInnerClasses = "flex flex-wrap items-center justify-between container";

const togglerClasses =
    "py-1 px-3 text-xl leading-none bg-transparent " +
    "border border-transparent rounded transition-shadow duration-150 lg:hidden";

const collapseClasses =
    "basis-full grow items-center lg:flex! lg:basis-auto";

const navListClasses =
    "flex flex-col lg:flex-row pl-0 mb-0 list-none " +
    "ml-auto! lg:mb-0!";

const superNavLinkClasses = `${navLinkClasses} lg:px-1`;

// The avatar is a sibling of the link, not part of it: inside, its 40px box
// stretched the active tab's underline half again past the label.
const profileItemClasses = "nav-item profile flex items-center";

const profileImgClasses = "max-w-full h-auto";
const brandWrapperClasses = "flex items-center gap-3";

const NAV_ITEMS = [
    { to: '/super/dashboard', label: 'Dashboard' },
    { to: '/super/analytics', label: 'Analytics' },
    { to: '/super/sales', label: 'Sales' },
    { to: '/super/reports', label: 'Reports' },
    { to: '/super/discoveryTemplate', label: 'Discovery Template', hidden: Constants.isDiscoveryHidden },
    { to: '/super/companies', label: 'Companies' },
    { to: '/super/users', label: 'Users' },
]



const TopNavBar = ({ profileImageUrl, setOpen }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
    <nav className={navClasses}>
    <div className={navInnerClasses}>
        <div className={brandWrapperClasses}>
            <NavBrand to='/super/dashboard' />
        </div>
        
        <XButton variant="close" className={togglerClasses}
            onClick={() => setIsMenuOpen(prev => !prev)}
            aria-controls="navbarSupportedContent" aria-expanded={isMenuOpen} aria-label="Toggle navigation">
            <span className="dp-navbar-toggler-icon"></span>
        </XButton>
        <div className={cn(collapseClasses, isMenuOpen ? "flex" : "hidden")} id="navbarSupportedContent">
            <ul className={navListClasses}>

                {NAV_ITEMS
                    .filter((item) => !item.hidden)
                    .map(({ to, label }) => (
                    <NavItem key={to} to={to}>{label}</NavItem>
                ))}

                <li className="nav-item">
                    <NavLink className={superNavLinkClasses} to="/super/design">Design Docs</NavLink>
                </li>

                <li className={profileItemClasses}>
                    <NavLink className={superNavLinkClasses} to="profile">My Profile</NavLink>
                    <RenderIf shouldRender={profileImageUrl}>
                        <img alt="" src={profileImageUrl} className={profileImgClasses} />
                    </RenderIf>
                </li>
                <li className={navButtonItemClasses}>
                    <XButton variant="navOutline" onClick={() => setOpen(true)}>
                        Logout
                    </XButton>
                    
                </li>
            </ul>
        </div>
    </div>
    </nav>
    );
};

export default SuperAdminLayout;